import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kh-settings-link',
  styleUrls: ['./settings-link.component.less'],
  templateUrl: './settings-link.component.html',
  standalone: false
})
export class SettingsLinkComponent {
  @Input() public label = '';
  @Input() public value = '';
  @Input() public linkLabel = 'go';
  @Input() public showLinkLabel = true;
  @Input() public testId = '';
  @Output() public actionClicked = new EventEmitter<void>();

  public clickAction(): void {
    this.actionClicked.emit();
  }
}
